/** 社交 API（so-api.aicocloud.com）：小程序列表、日志、设置、授权链接 */
export const SOCIAL_API_ORIGIN = (
  process.env.VUE_APP_SOCIAL_API || "https://so-api.aicocloud.com"
).replace(/\/$/, "");

export const ADMIN_MICOAPP_API = `${SOCIAL_API_ORIGIN}/admin/micoapp`;
export const ADMIN_LOGIN_API = `${SOCIAL_API_ORIGIN}/admin/login`;
export const OAUTH_LOGIN = `${SOCIAL_API_ORIGIN}/oauth/login`;
export const OAUTH_REVOKE = `${SOCIAL_API_ORIGIN}/oauth/revoke`;
export const COMPONENT_API = `${SOCIAL_API_ORIGIN}/component/api`;
export const UPLOAD_API = `${SOCIAL_API_ORIGIN}/upload`;

export function settingPayload(body) {
  if (!body || typeof body !== "object") return {};
  if (body.setting && typeof body.setting === "object") return body.setting;
  if (body.data && typeof body.data === "object" && !Array.isArray(body.data)) {
    return body.data;
  }
  return {};
}

export function apiErrorText(body, fallback) {
  if (!body || typeof body !== "object") return fallback || "";
  return body.msg || body.message || fallback || "";
}
